import clsx from "clsx";
import styles from "./Link.module.css";
import BaseLink from "../BaseLink";
import { LinkProps } from "../types";

const Link = (props: LinkProps) => {
  const { children, className, ...rest } = props;

  return (
    <BaseLink className={clsx(styles.link, className)} {...rest}>
      {children}
    </BaseLink>
  );
};

export default Link;
